/** Warm restaurant brand — matches POS redesign mockup (Jun 2026). */
export const BRAND = {
  orange: "#F36F21",
  orangeLight: "#FF8A3D",
  orangeDark: "#D95A0E",
  brown: "#2B0B04",
  brownMid: "#4A1810",
  brownSoft: "#6B3A2E",
  cream: "#FDF8F5",
  creamPanel: "#FFF3E8",
  creamBorder: "#F0E0D4",
  white: "#FFFFFF",
  green: "#22A55B",
  greenDark: "#1A8F4A",
  red: "#DC2626",
  redSoft: "#FEE2E2",
  text: "#2B0B04",
  textMuted: "#8B6B5E",
};

/** Category icons for POS left rail (emoji for compact 15" tiles). */
export const CAT_ICONS = {
  Shawarma: "🌯",
  Grills: "🍖",
  "Mandi & Rice": "🍚",
  Mezze: "🥗",
  Burgers: "🍔",
  Juices: "🧃",
  Shakes: "🥤",
  "Hot Drinks": "☕",
  Desserts: "🍰",
  Combos: "🍱",
  Default: "🍽️",
};

export function getCatIcon(name) {
  return CAT_ICONS[name] || CAT_ICONS.Default;
}

/** POS operation button styles — pastel tiles with icons (mockup). */
export const POS_ACTION_STYLES = {
  hold:      { bg: "#FEF3C7", border: "#F59E0B", text: "#92400E" },
  recall:    { bg: "#DBEAFE", border: "#3B82F6", text: "#1E40AF" },
  void:      { bg: "#FEE2E2", border: "#EF4444", text: "#991B1B" },
  discount:  { bg: "#EDE9FE", border: "#8B5CF6", text: "#5B21B6" },
  kotsend:   { bg: "#D1FAE5", border: "#10B981", text: "#065F46" },
  kotreprint:{ bg: "#FEF3C7", border: "#D97706", text: "#78350F" },
  knote:     { bg: "#CCFBF1", border: "#14B8A6", text: "#115E59" },
  rate:      { bg: "#FCE7F3", border: "#EC4899", text: "#9D174D" },
  parcel:    { bg: "#CFFAFE", border: "#06B6D4", text: "#155E75" },
  return:    { bg: "#FEE2E2", border: "#F87171", text: "#991B1B" },
  credit:    { bg: "#F1F5F9", border: "#94A3B8", text: "#334155" },
  fast:      { bg: "#FFEDD5", border: "#F97316", text: "#9A3412" },
  combo:     { bg: "#EDE9FE", border: "#A78BFA", text: "#5B21B6" },
  mark:      { bg: "#DBEAFE", border: "#60A5FA", text: "#1E40AF" },
  drawer:    { bg: "#D1FAE5", border: "#34D399", text: "#065F46" },
  clear:     { bg: "#FEE2E2", border: "#EF4444", text: "#991B1B" },
  splitbill:     { bg: "#FEF3C7", border: "#FBBF24", text: "#92400E" },
  mergetable:    { bg: "#E0E7FF", border: "#6366F1", text: "#3730A3" },
  transfertable: { bg: "#CFFAFE", border: "#22D3EE", text: "#155E75" },
  changewaiter:  { bg: "#FCE7F3", border: "#F472B6", text: "#9D174D" },
  kothistory:    { bg: "#FFEDD5", border: "#FB923C", text: "#9A3412" },
  openbills:     { bg: "#DBEAFE", border: "#3B82F6", text: "#1E40AF" },
  pendingorders: { bg: "#D1FAE5", border: "#34D399", text: "#065F46" },
  closeshift:    { bg: "#FEE2E2", border: "#EF4444", text: "#991B1B" },
};
